var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('div',{ref:"chat",class:_vm.$style.chat},[_c('ChatMessages',{on:{"infinite":_vm.onLoadMessages}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }